export const getConfirmationOrder = () => ({
    type: 'GET_CONFIRAMTION_ORDER_INFO'
});

export const getChatInfo = (params) => ({
    type: 'GET_CHAT_INFO',
    params,
})

export const getOmniOloDetails = (data) => ({
    type: "GET_OMNI_OLO_DETAILS",
    data
});
